/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Only production builds report. The dev stores and localhost build with the
// development configuration (environment.production false) and were filling
// the production quota with their own errors.
if (environment.production) {
  Sentry.init({
    dsn: "https://cbad533acdc4ae4350482fb8bcfbe3d5@o4508162247557120.ingest.us.sentry.io/4509123747315712",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // A tab still on the previous build asks for lazy chunks the deploy removed.
    // ChunkReloadErrorHandler reloads it onto the new build, so these are not
    // actionable, and right after a deploy they arrive in bursts large enough to
    // exhaust the Sentry quota (429s). Drop them at the source.
    ignoreErrors: [
      'Failed to fetch dynamically imported module',
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to load module script',
      /Loading (CSS )?chunk/,
      'ChunkLoadError',
      'NG0750',
    ],
    // Tracing
    tracesSampleRate: 0, // off: transactions were burning the shared quota (DEV-11772)
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/carltonfarms\.navego\.tech/,
      /^https:\/\/carltonfarms\.com/,
    ],
    // Session Replay (integration registered lazily — see below).
    replaysSessionSampleRate: 0, // record only the sessions that hit an error
    replaysOnErrorSampleRate: 1.0,
  });

  // Fetch the Replay integration from Sentry's CDN after the page is interactive
  // so it doesn't ship in the eager bundle (~120 KB). Replay records on error
  // only, so the brief window before it registers is acceptable.
  const loadReplay = async () => {
    try {
      const replayIntegration = await Sentry.lazyLoadIntegration('replayIntegration');
      Sentry.getClient()?.addIntegration(replayIntegration());
    } catch {
      // Non-critical: if the CDN fetch fails we just lose replay for this session.
    }
  };
  const scheduleReplay = () => {
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(loadReplay, { timeout: 2000 });
    } else {
      setTimeout(loadReplay, 2000);
    }
  };
  if (document.readyState === 'complete') {
    scheduleReplay();
  } else {
    window.addEventListener('load', scheduleReplay, { once: true });
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
